<div *ngIf="message" class="alert alert-{{message.cssClass}}">
    {{message.text}}
    <a class="close" (click)="clear()">&times;</a>
    <div class="progress">
        <div class="progress-bar bg-{{message.cssClass}}" role="progressbar" style="width: 0%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</div>
